export default "__VITE_ASSET__Bwo0w24N__"